__turbopack_context__.v({
  "hr": "qoqo6W_hr",
  "line": "qoqo6W_line",
  "text": "qoqo6W_text",
  "withLabel": "qoqo6W_withLabel",
  "wrapper": "qoqo6W_wrapper",
});
